<template>
  <v-menu
    bottom
    min-width="200px"
    rounded
    offset-y
    nudge-bottom="6"
    v-if="user.id"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon x-large v-on="on">
        <avatar-image
          :url="user.profile_pic ? user.profile_pic.file_url : ''"
        />
      </v-btn>
    </template>
    <v-card>
      <v-list-item-content class="justify-center">
        <div class="mx-auto text-center cursor-pointer">
          <div @click="handleToProfile">
            <avatar-image
              :url="user.profile_pic ? user.profile_pic.file_url : ''"
            />
            <h3 class="mt-2">
              {{ user.display_name }}
            </h3>
            <p class="caption mt-1">
              {{ parseUserRoleText(user) }}
            </p>
          </div>

          <v-divider class="my-3" />
          <btn
            color="black"
            depressed
            rounded
            text
            :to="appRoutes.userProfile(user.id)"
          >
            {{ $t("profile") }}
            <v-icon right>mdi-account</v-icon>
          </btn>
          <v-divider class="my-3" />

          <btn color="black" depressed rounded text :to="appRoutes.activityLog">
            {{ $t("activityLogs") }}
            <v-icon right>mdi-post</v-icon>
          </btn>
          <v-divider class="my-3" />

          <btn
            color="black"
            depressed
            rounded
            text
            @click="$root.$emit(GLOBAL_EVENT_SHOW_SETTINGS)"
          >
            {{ $t("settings") }}
            <v-icon right>mdi-account-cog</v-icon>
          </btn>

          <v-divider class="my-3" />
          <btn
            color="black"
            depressed
            rounded
            text
            @click="$root.$emit(GLOBAL_EVENT_SHOW_ROLE_CHANGE_MODAL)"
          >
            {{ $t("changeRoleModal.openButton") }}
            <v-icon right>mdi-account-switch</v-icon>
          </btn>
          <template v-if="$p(permissions.system.support)">
            <v-divider class="my-3" />

            <btn
              color="black"
              depressed
              rounded
              text
              :href="KNOWLEDGE_BASE_URL"
              target="_blank"
            >
              {{ $t("support") }}
            </btn>
          </template>

          <template v-if="$p(permissions.system.logout)">
            <v-divider class="my-3" />

            <btn
              @click="$root.$emit(GLOBAL_EVENT_LOGOUT)"
              color="black"
              depressed
              rounded
              text
            >
              {{ $t("logout") }}
              <v-icon right>mdi-logout</v-icon>
            </btn>
          </template>
        </div>
      </v-list-item-content>
    </v-card>
  </v-menu>
</template>

<script>
import userMixin from "Shared/mixins/userMixin";
import AvatarImage from "Public/components/AppBar/components/avatar/AvatarImage";
import Btn from "Shared/components/Public/General/Buttons/Btn";
import {
  GLOBAL_EVENT_LOGOUT,
  GLOBAL_EVENT_SHOW_SETTINGS,
  GLOBAL_EVENT_SHOW_ROLE_CHANGE_MODAL,
} from "Consts/globalEvents";
import { appRoutes } from "Public/consts/appRoutes";
import { permissions } from "Consts/permissions";
import { parseUserRoleText } from "Shared/helpers/parseUserRoleText";
import { KNOWLEDGE_BASE_URL } from "Consts/static";

export default {
  name: "avatar",
  components: { Btn, AvatarImage },
  mixins: [userMixin],
  props: {
    url: {
      type: String,
    },
  },
  data() {
    return {
      KNOWLEDGE_BASE_URL,
      parseUserRoleText,
      permissions,
      GLOBAL_EVENT_SHOW_SETTINGS,
      GLOBAL_EVENT_SHOW_ROLE_CHANGE_MODAL,
      GLOBAL_EVENT_LOGOUT,
      appRoutes,
    };
  },
  methods: {
    async handleToProfile() {
      await this.$router.push(appRoutes.userProfile(this.user.id));
    },
  },
};
</script>

<style scoped></style>
